export const spacing = {
    spacing_0: "0rem", // 0px
    spacing_2: "0.125rem", // 2px
    spacing_4: "0.25rem", // 4px
    spacing_6: "0.375rem", // 6px
    spacing_8: "0.5rem", // 8px
    spacing_10: "0.625rem", // 10px
    spacing_12: "0.75rem", // 12px
    spacing_14: "0.875rem", // 14px
    spacing_16: "1rem", // 16px
    spacing_20: "1.25rem", // 20px
    spacing_22: "1.375rem", // 22px
    spacing_24: "1.5rem", // 24px
    spacing_28: "1.75rem", // 28px
    spacing_32: "2rem", // 32px
    spacing_36: "2.25rem", // 36px
    spacing_40: "2.5rem", // 40px
    spacing_48: "3rem", // 48px
    spacing_64: "4rem", // 64px
    spacing_80: "5rem", // 80px
    spacing_96: "6rem", // 96px
    spacing_112: "7rem", // 112px
    spacing_128: "8rem" // 128px
};
